'use client';

import type { FC } from 'react';
import { GDPR } from '@/components/GDPR';
import { useSiteContext } from '@/context/SiteContext';
import { typeGuards } from '@themaven-net/smart-slots';
import { useLoadScript } from '@/context/ScriptsContext';

interface SellwildProps {
	src: string;
}

const SellwildBase: FC<SellwildProps> = ({ src }) => {
	useLoadScript('sellwild', src);
	return <sellwild-widget />;
};

export const Sellwild: FC = () => {
	const {
		config: {
			smartSlotConfig: { widgets },
		},
	} = useSiteContext();
	const { src } =
		Object.values(widgets).find(typeGuards.isSellwildWidget)?.config ?? {};
	if (!src) {
		return false;
	}
	return (
		<GDPR purposes={['measurement/advertising']} vendorId="sellwild">
			<SellwildBase src={src} />
		</GDPR>
	);
};
